import { render } from "./SubmenuTopHelp.vue?vue&type=template&id=00a7a78e&scoped=true"
import script from "./SubmenuTopHelp.vue?vue&type=script&lang=js"
export * from "./SubmenuTopHelp.vue?vue&type=script&lang=js"

import "./SubmenuTopHelp.vue?vue&type=style&index=0&id=00a7a78e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a7a78e"]])

export default __exports__